import Appsignal from '@appsignal/javascript';
import { readVarM } from '@execonline-inc/environment';
import { Maybe } from 'maybeasy';

const appsignalKey = readVarM('VITE_APP_APPSIGNAL_PUSH_API_KEY');

export const appsignalP3: Maybe<Appsignal> = appsignalKey.map(
  (key: string) =>
    new Appsignal({
      key: key,
      namespace: 'platform',
    }),
);

export const appsignalDiscoveryPortal: Maybe<Appsignal> = appsignalKey.map(
  (key: string) =>
    new Appsignal({
      key: key,
      namespace: 'discovery_portal',
    }),
);
